"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const context_1 = require("../../../context");
const routeContainers_1 = require("../../../comps/routeContainers");
const GizmodoDocs_1 = require("./docs/GizmodoDocs");
const VoxDocs_1 = require("./docs/VoxDocs");
const OsmosysHelpHome_1 = require("./OsmosysHelpHome");
const LaTimesDocs_1 = require("./docs/LaTimesDocs");
const SdutDocs_1 = require("./docs/SdutDocs");
const SupChinaDocs_1 = require("./docs/SupChinaDocs");
exports.OsmosysHelp = () => {
    return (react_1.default.createElement("div", { className: "d-flex flex-column flex-grow-1" },
        react_1.default.createElement(context_1.OsmosysAppContext.Consumer, null, ({ currentUser, appHasLoaded }) => {
            const hasWorkspace = appHasLoaded &&
                currentUser &&
                currentUser.currentWorkspaceMembership &&
                currentUser.currentWorkspaceMembership.workspace;
            const standardDocPage = (react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/help", exact: true, component: OsmosysHelpHome_1.OsmosysHelpHome }),
                ' ',
                react_1.default.createElement(react_router_dom_1.Redirect, { to: "/help" }),
                ' '));
            if (!hasWorkspace) {
                return standardDocPage;
            }
            const workspace = currentUser.currentWorkspaceMembership.workspace;
            if (!workspace.helpLink) {
                return standardDocPage;
            }
            if (workspace.name.toLowerCase().includes('supchina')) {
                return (react_1.default.createElement(react_router_dom_1.Switch, null,
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: workspace.helpLink, exact: true, component: SupChinaDocs_1.SupChinaDocs }),
                    react_1.default.createElement(react_router_dom_1.Redirect, { to: workspace.helpLink })));
            }
            if (workspace.name.toLowerCase().includes('vox')) {
                return (react_1.default.createElement(react_router_dom_1.Switch, null,
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: workspace.helpLink, exact: true, component: VoxDocs_1.VoxDocs }),
                    react_1.default.createElement(react_router_dom_1.Redirect, { to: workspace.helpLink })));
            }
            if (workspace.name.toLowerCase().includes('l.a. times') ||
                workspace.name.toLowerCase().includes('la times') ||
                workspace.name.toLowerCase().includes('los angeles times')) {
                return (react_1.default.createElement(react_router_dom_1.Switch, null,
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: workspace.helpLink, exact: true, component: LaTimesDocs_1.LaTimesDocs }),
                    react_1.default.createElement(react_router_dom_1.Redirect, { to: workspace.helpLink })));
            }
            if (workspace.name.toLowerCase().includes('sdut') ||
                workspace.name.toLowerCase().includes('san diego union')) {
                return (react_1.default.createElement(react_router_dom_1.Switch, null,
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: workspace.helpLink, exact: true, component: SdutDocs_1.SdutDocs }),
                    react_1.default.createElement(react_router_dom_1.Redirect, { to: workspace.helpLink })));
            }
            if (workspace.name.toLowerCase().includes('giz')) {
                return (react_1.default.createElement(react_router_dom_1.Switch, null,
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: workspace.helpLink, exact: true, component: GizmodoDocs_1.GizmodoDocs }),
                    react_1.default.createElement(react_router_dom_1.Redirect, { to: workspace.helpLink })));
            }
            return standardDocPage;
        })));
};
exports.default = exports.OsmosysHelp;
//# sourceMappingURL=index.js.map